export const routeToCustomerLoginUrl = (customer: string, queryParams?: Record<string, string>) => {
  const currentCustomer = extractCustomerFromUrl()
  let redirectUrl = window.location.origin.replace(`${currentCustomer}.`, `${customer}.`) + '/login'
  if (queryParams) {
    const searchParams = new URLSearchParams(queryParams)
    redirectUrl += `?${searchParams.toString()}`
  }
  window.location.replace(redirectUrl)
}

const extractCustomerFromUrl = () => {
  const { host } = window.location
  return host.substring(0, host.indexOf('.'))
}
